import { Component, OnInit, ViewChild } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';

@Component({
  selector: 'app-wellcome',
  templateUrl: './wellcome.component.html',
  styleUrls: ['./wellcome.component.css']
})
export class WellcomeComponent extends SiriusBaseComponent<any> {

  amount: number;

  @ViewChild('captcha') captcha: any;
  public captchaValue: string;

  public validate(): void {
    let captchaSuccess = this.captcha.validate();
    console.log('Success: ' + captchaSuccess);
  }

  OnInit() {
    
  }

  constructor() {
      super();
  }
  handleFocus(e: any) {

  }

  handleBlur(e: any) {

  }

  handleValueChanged(e: any) {

  }
  showError(): boolean {
    return this.amount === 0;
  }
}
